<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white"> Abastecimientos </h4>
            </div>
            <div class="card-body">
                <form class="form-horizontal" #clienteContratoForm="ngForm">
                    <!--
                    <div class="col-md-3">
                        <h3>Contrato de cliente: </h3>
                    </div>
                    <br/>
                    <table class="col-lg-10">
                        <thead>
                            <td><b>Contrato</b></td>
                            <td><b>Fecha de inicio de contrato</b></td>
                            <td><b>Días de duración de servicio</b></td>
                        </thead>
                        <tbody>
                            <tr></tr>
                            <tr>
                                <td>{{contrato}}</td>
                                <td>{{fechaInicio}}</td>
                                <td>{{dias}}</td>
                            </tr>
                        </tbody>
                    </table>
                    -->
                    <div class="form-body">
                        <!-- Documento Contrato Inicio -->
                        <!--
                        <div class="form-group col-sm-12 col-md-12 col-lg-12">
                            <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">{{ FORMS.crearCliente.contrato.titulo }}</label>
                            <div class="col-md-12">
                                <input type="file" class="btn btn-outline-info" id="CONTRATO" data-show-loader="true" data-allowed-file-extensions="pdf png jpg" data-max-file-size="5M" [disabled]="deshabilitarCamposPermisoEditar || estatusDocumentoEstatus === 'AUTCOMP'" />                                &nbsp; &nbsp; &nbsp;
                                <button type="button" style="font-size: 15px; text-align: center" class="btn btn-info" data-toggle="modal" data-target="#documentoPopUp" *ngIf="estatusDocumentoEstatus !== 'NOTEXIS' " (click)="documentoPopUp()">
                                    {{ PAGE.verCliente.verDocumento }}
                                </button> &nbsp; &nbsp; &nbsp;
                                <button *ngIf="visto; else sinNotiCon" type="button" style="font-size: 15px; text-align: center" class="btn btn-primary" data-toggle="modal" data-target="#comentarioPopUp">
                                    <span class="parpadea text">{{ PAGE.verCliente.verComentario }}</span>
                                </button> &nbsp; &nbsp; &nbsp;
                                <ng-template #sinNotiCon>
                                    <button type="button" style="font-size: 15px; text-align: center" class="btn btn-primary" data-toggle="modal" data-target="#comentarioPopUp">
                                        {{ PAGE.verCliente.verComentario }}
                                    </button> &nbsp; &nbsp; &nbsp;
                                </ng-template>
                                <label> {{ estatusDocumentoNombre }}</label> &nbsp; &nbsp; &nbsp;
                                <span [class]="iconoForma" [style.color]='iconoColor' style="font-size: 30px"></span> &nbsp; &nbsp; &nbsp;
                            </div>
                            <button type="button" class="btn botonActualizarContrato" id="actuContrato" *ngIf="btnActualizarContrato && btnRegistrarContrato" (click)="actualizarContrato()">
                                Actualizar contrato
                            </button>
                        </div>
                        <hr class="mt-5 m-b-40 ">
                        -->
                        <!-- Documento Contrato Fin -->
                    </div>
                </form>
            </div>
            <!-- Documento Contrato Fin -->
            <!-- Botones: Alquiles, prórroga y venta -->
            <!-- *ngIf: botonesPermisos.crearAbastecimiento controla si tiene los permisos para poder registrar un abastecimiento -->
            <div class="col-md-12" style="text-align: center" *ngIf="botonesPermisos.crearAbastecimiento; else noPermitido">
                <div class="col-md-12">
                    <!-- id="titulo" -->
                    <h3>Realizar un abastecimiento: </h3>
                </div>
                <br>
                <!-- Alquiler -->
                <!-- *ngIf: btnRegistrarContrato: Se visualiza si el contrato ya ha sido autorizado. -->
                <!--
                <button type="button" id="alquiler" [disabled]="btnAlquiler" class="btn botonAlquiler col-sm-4 col-lg-2 mt-2" *ngIf="!btnRegistrarContrato; else noAbastecimiento" (click)="alquiler()">
                    Alquiler
                </button> &nbsp;&nbsp;&nbsp;&nbsp;
                <ng-template #noAbastecimiento>
                    <button type="button" id="alquiler" class="btn botonAlquiler col-sm-4 col-lg-2 mt-2" (click)="swalSinAbastecimiento()">
                        Alquiler
                    </button> &nbsp;&nbsp;&nbsp;&nbsp;
                </ng-template>
                -->
                <!-- Prorroga -->
                <!-- ============= -->
                <button class="btn botonPorroga col-sm-4 col-lg-3 mt-3" type="button" id="alquiler" [disabled]="!btnPermitirUnaProrroga" *ngIf="btnRegistrarContrato; else noProrroga" (click)="prorroga()">
                    Reabastecimiento
                </button> &nbsp;&nbsp;&nbsp;&nbsp;
                <ng-template #noProrroga>
                    <button class="btn botonPorroga col-sm-4 col-lg-3 mt-3" type="button" id="alquiler" [disabled]="!btnPermitirUnaProrroga" (click)="swalSinAbastecimiento()">
                        Reabastecimiento
                    </button>
                </ng-template>
                <!--
                <button type="button" id="prorroga" [disabled]="btnProrroga" class="btn botonPorroga col-sm-4 col-lg-2 mt-2" *ngIf="btnRegistrarContrato; else noProrroga" (click)="swalSinAbastecimiento()">
                    Prórroga
                </button> &nbsp;&nbsp;&nbsp;&nbsp;
                -->
                <!--
                <ng-template #noProrroga>
                    <button type="button" id="alquiler" [disabled]="btnProrroga" class="btn botonPorroga col-sm-4 col-lg-2 mt-2" *ngIf="btnPermitirProrroga; else prorrogaPermitida" (click)="swalPermitirProrroga()">
                        Prorroga
                    </button> &nbsp;&nbsp;&nbsp;&nbsp;
                </ng-template>
                -->
                <!-- Prorroga prueba -->
                <!--
                <ng-template #prorrogaPermitida>
                    <button type="button" id="alquiler" [disabled]="!btnPermitirUnaProrroga" class="btn botonPorroga col-sm-4 col-lg-2 mt-2" (click)="prorroga()">
                        Prorroga
                    </button> &nbsp;&nbsp;&nbsp;&nbsp;
                </ng-template>
                -->
                <!-- Prorroga prueba -->
                <!-- ================ -->
                <!-- Prorroga -->
                <!-- Venta -->
                <!--
                <button type="button" id="venta" class="btn botonVenta col-sm-4 col-lg-2 mt-2" *ngIf="!btnRegistrarContrato; else noVenta" (click)="venta()">
                    Venta
                </button>
                <ng-template #noVenta>
                    <button type="button" id="alquiler" class="btn botonVenta col-sm-4 col-lg-2 mt-2" (click)="swalSinAbastecimiento()">
                        Venta
                    </button> &nbsp;&nbsp;&nbsp;&nbsp;
                </ng-template>
                <br>
                -->
                <!-- *ngIf="botonesPermisos.crearProd" routerLink="/dashboard/crearProducto" -->
                <hr class="mt-5 m-b-40 ">
            </div>
            <ng-template #noPermitido></ng-template>
            <!-- Botones: Alquiles, prórroga y venta -->
            <div class="col-md-12">
                <h3>Abastecimientos correspondientes a este contrato: {{ contrato }}</h3>
            </div>
            <div class="table-responsive">
                <table datatable [dtOptions]="dtOptions" id="dataTableAbastecimientos" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Concepto</th>
                            <th>Fecha de registro de contrato</th>
                            <th>Estatus</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let abastecimiento of contratosArray" (click)="IdAbastecimiento(abastecimiento.idAbas)">
                            <td>{{ abastecimiento.id }}</td>
                            <td>{{ abastecimiento.concepto }}</td>
                            <td>{{ abastecimiento.lapso }}</td>
                            <td><span class="label" [style.background]="abastecimiento.estatusColor">{{ abastecimiento.estatusNombre }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<!-- Comentario popup -->
<div id="comentarioPopUp" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" id="comentarioPopUpArea">
            <div class="modal-header">
                <h4 class="modal-title">Comentarios de documento</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div id="contenidoModalComentario">
                <div class="m-t-5" *ngIf="comentariosContratoArray.length === 0">
                    <h2>No hay comentarios o se están cargando</h2>
                </div>
                <div id="cajaComentario">
                    <ul class="chat-list" *ngFor="let mensaje of comentariosContratoArray">
                        <!-- Chat Row -->
                        <li *ngIf="mensaje.username !== usuario.userName">
                            <div class="chat-img"><img src="{{API.archivos + mensaje.imagenPerfil}}" alt="user" /></div>
                            <!-- src="../assets/images/users/1.jpg" -->
                            <div class="chat-content">
                                <h5>{{ mensaje.username }}</h5>
                                <div class="box bg-light-info">
                                    {{ mensaje.comentario }}
                                </div>
                            </div>
                            <div class="chat-time">{{ mensaje.fecha }}</div>
                        </li>
                        <!-- Chat Row -->
                        <li class="reverse" *ngIf="mensaje.username === usuario.userName">
                            <div class="chat-content">
                                <h5>Tú: {{ mensaje.username }}</h5>
                                <div class="box bg-light-inverse">{{ mensaje.comentario }}</div>
                            </div>
                            <div class="chat-img"><img src="{{API.archivos + mensaje.imagenPerfil}}" alt="user" /></div>
                            <div class="chat-time">{{ mensaje.fecha }}</div>
                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <div class="card-body b-t">
                        <div class="row">
                            <div class="col-8">
                                <textarea class="form-control areaComentario b-0" [placeholder]="PAGE.verCliente.escribirMensaje" [(ngModel)]="currentMensajeComentarioPopUp" [disabled]="enviandoMensajeComentarioPopUp" (click)="comentarioDoble()">
                                </textarea>
                            </div>
                            <div class="col-4 text-right">
                                <button type="button" class="btn btn-info btn-circle btn-lg" [disabled]="enviandoMensajeComentarioPopUp" (click)="enviarComentarioContrato()">
                                    <i *ngIf="!enviandoMensajeComentarioPopUp" class="fa fa-paper-plane-o"></i>
                                    <i *ngIf="enviandoMensajeComentarioPopUp" class="fa fa-spin fa-spinner"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Documento popup -->
<div id="documentoPopUp" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" id="documentoPopUpArea">
            <div class="modal-header">
                <h4 class="modal-title">Vista previa: {{ mostrarBotones[0].popUpHeaderText }} </h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>

            <div class="imgsrc" *ngIf="tipoDeContrato !== 'pdf'; else pdf">
                <ngx-imageviewer [src]="imageSrc"></ngx-imageviewer>
            </div>
            <ng-template #pdf>
                <div class="imgsrc">
                    <div *ngIf="innerHtml" [innerHTML]="innerHtml">
                    </div>
                </div>
            </ng-template>

            <div class="modal-footer">
                <a href="{{ imageSrc }}" class="btn btn-info" target="_blank">{{PAGE.verCliente.descargarDocumento}}</a>
                <!-- class="btn btn-info" href="imageSrc" target="_blank" -->
                <div *ngIf="mostrarBotones[0].autorizarDocumentoBtn">
                    <button type="button" class="btn btn-success" (click)="cambiarEstatusDocumento('AUTCOMP')">
                        <!-- *ngIf="botonesPermisos.crearAbastecimiento" -->
                        {{ PAGE.verCliente.autorizarDocumento }}
                    </button>
                    <button type="button" class="btn btn-danger" (click)="cambiarEstatusDocumento('AUTDENE')">
                        {{ PAGE.verCliente.rechazarDocumento }} 
                    </button>
                </div>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/listar-abastecimiento/listar-abastecimiento.component.html